import React, { useState } from 'react';
import SearchMeters from './SearchMeters';
import EditMeter from './EditMeter';
import { useRouteMatch } from "react-router-dom";

const Meters = ({ helpLink }) => {

    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [results, setResults] = useState();

    const match = useRouteMatch('/dashboard/meters/:spid')

    const spid = match && match.params && match.params.spid;

    return (
        <>
            <div className="wrapper mt-60px mb-20px">
                {!spid ? (
                    <>
                        <div className="grid grid-cols-1 sm:grid-cols-9 gap-20px sm:gap-40px mb-10px">
                            <div className="sm:col-span-5">
                                <h2 className="text-everflow-black font-bold mb-20px">Your locations</h2>
                                <p className="text-everflow-black leading-6"><b>The best thing you can do to manage your bills is to send us regular meter readings.</b> If you send us monthly reads, we can include these in your next invoice. We will still send our team out to read your meters twice a year.</p>
                            </div>
                        </div>
                        <SearchMeters
                            search={search}
                            setSearch={setSearch}
                            page={page}
                            setPage={setPage}
                            results={results}
                            setResults={setResults}
                            helpLink={helpLink}
                        />
                    </>
                ) : (
                    <EditMeter
                        spid={spid}
                    />
                )}
            </div>
        </>
    )
}

export default Meters;